/**
 * Dashboard Feature Components
 */

export function WodHeroComponent() {
    return {
        checks: {},

        init() {
            try {
                this.checks = JSON.parse(sessionStorage.getItem('training_checks') || '{}');
            } catch (e) {
                this.checks = {};
            }
        },

        get doneCount() {
            return Object.values(this.checks).filter((v) => v === true).length;
        },
    };
}
